import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const Commit = () => {

    const { sha } = useParams();

    const [commit, setCommit] = useState({
        owner: null,
        name: null,
        keywords: [],
        author: null,
        message: null,
        file_name: null,
        sha: null,
    });

    // Get the shas from local storage and see if the current sha is in the list
    const shas = JSON.parse(localStorage.getItem("shas")) || [];
    const isInList = shas.includes(sha);

    const [diff, setDiff] = useState('');

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_commit_diff/' + sha, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setDiff(data.diff);  // Assuming the backend returns { diff: "..." }
            })
            .catch(error => {
                console.error("Error fetching diff:", error);
            });
    }, [sha]);
    


    function eval_commit() {
        let isSecurity = document.getElementById('isSecurity').value;
        let reason = document.getElementById('reason').value;
        let mentions_security = document.getElementById('mentions_security').value;
        let comment = document.getElementById('comment').value;

        if (isSecurity === 'Select' || reason === '' || mentions_security === 'Select') {
            alert('Please fill all fields');
            return;
        }

        fetch(process.env.REACT_APP_BACKEND_URL + 'eval_ds_commit', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user"),
                sha: sha,
                isSecurity: isSecurity === 'true',
                reason: reason,
                mentions_security: mentions_security === 'true',
                comment: comment
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.res === 'ok') {
                    alert('Commit evaluated');
                } else {
                    alert('Error Commit review');
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });

    }

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_ds_commit/' + sha, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setCommit(data);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [sha]);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_eval_ds_commit/' + sha, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user"), reviewer: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.security === null) document.getElementById('isSecurity').value = 'Select';
                else document.getElementById('isSecurity').value = data.security ? 'true' : 'false';
                if (data.mentions_security === null) document.getElementById('mentions_security').value = 'Select';
                else document.getElementById('mentions_security').value = data.mentions_security ? 'true' : 'false';
                document.getElementById('reason').value = data.reason;
                document.getElementById('comment').value = data.comment;
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [sha]);


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Commit</h1>
                </div>
            </div>

            {/* If the commit is in the list of shas, show arrows that redirecto to the previous and next commits */}
            <div>
                {isInList && (
                    <div className="flex justify-between">
                        {shas.indexOf(sha) > 0 && (
                            <Link to={'/commit/' + shas[shas.indexOf(sha) - 1]}>
                                <button className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow">
                                    Previous
                                </button>
                            </Link>
                        )}
                        {shas.indexOf(sha) < shas.length - 1 && (
                            <Link to={'/commit/' + shas[shas.indexOf(sha) + 1]}>
                                <button className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow">
                                    Next
                                </button>
                            </Link>
                        )}
                    </div>
                )}
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12 grid md:grid-cols-4 gap-4 sm:grid-cols-1">
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Repository:</h1>
                    <p>{commit.owner}/{commit.name}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">File:</h1>
                    <p>{commit.path}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL:</h1>
                    <Link target="_blank" to={'https://github.com/' + commit.owner + '/' + commit.name + '/commit/' + sha}>
                        <p className="text-blue-500 hover:underline">
                            https://github.com/{commit.owner}/{commit.name}/commit/{sha}
                        </p>
                    </Link>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Evaluation:</h1>
                </div>
                <div className="grid md:grid-cols-4 gap-4 sm:grid-cols-1">
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Mentions Security:</label>
                        <select className="w-full" id="mentions_security">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Reason:</label>
                        <textarea type="text" id="reason" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Is Security:</label>
                        <select id="isSecurity" className="w-full">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Comment:</label>
                        <textarea type="text" id="comment" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>

                <div className="mt-4 flex grid justify-items-end gap">
                <button onClick={eval_commit}
                    className="rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-800"
                >
                    Evaluate
                </button>
                </div>
            </div>

            <div className="grid md:grid-cols-2 gap-2 sm:grid-cols-1">
                <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96 bg-white">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Author:</h1>
                    <p>{commit.author}</p>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Keywords:</h1>
                    <p>{commit.keywords.join(', ')}</p>
                </div>

                <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96 bg-gray-50 relative">
                    {/* Copy Button */}
                    <button
                        onClick={() => {
                            const textToCopy = `Message:\n${commit.message}\n\nFile Diff:\n${diff}`;
                            navigator.clipboard.writeText(textToCopy)
                                .catch(err => console.error('Failed to copy: ', err));
                        }}
                        className="absolute top-2 right-2 rounded-md bg-gray-800 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-800"
                    >
                        Copy
                    </button>

                    {/* Message and Diff */}
                    <h1 className="text-base font-semibold leading-7 text-gray-900 mt-6">Message:</h1>
                    <p>{commit.message}</p>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">File Diff:</h1>
                    <pre className="text-sm whitespace-pre-wrap text-left">{diff}</pre>
                </div>
            </div>



        </>
    );
}

export default Commit;